import { transformThresholdIntoIndicatorByLayout } from './utils/transform-threshold-into-indicator.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import {
  ThresholdIndicatorData,
  ThresholdIndicator,
} from '../../../core/components/threshold-bar/indicators/ThresholdIndicator.js';
import { isStatic } from '../../../core/types/type-guards.js';
import { useHoveredThresholdIdState } from '../../hooks/store/selectors.js';
import { useCategoricalBarChartBaseConfig } from '../../hooks/useCategoricalBarChartBaseConfig.js';
import { useCategoricalBarChartScales } from '../../hooks/useCategoricalBarChartScales.js';
import { useCategoricalBarChartThresholds } from '../../hooks/useCategoricalBarChartThresholds.js';

export const CategoricalThresholdIndicators = () => {
  const { valueScale } = useCategoricalBarChartScales();
  const thresholds = useCategoricalBarChartThresholds();
  const { layout } = useCategoricalBarChartBaseConfig();
  const { width, height } = useGridPlotSize();
  const hoveredThresholdId = useHoveredThresholdIdState();

  return (
    <>
      {thresholds.map(({ id, data, color, strokeOnly }, index) => {
        const indicatorData: ThresholdIndicatorData[] =
          transformThresholdIntoIndicatorByLayout(
            data,
            valueScale,
            layout,
            layout === 'vertical' ? width : height,
          );

        const isStrokeOnly = isStatic(data) || strokeOnly;

        return (
          <ThresholdIndicator
            key={`threshold-indicator-${index}`}
            data={indicatorData}
            color={color}
            strokeOnly={isStrokeOnly}
            isActive={hoveredThresholdId === id}
          />
        );
      })}
    </>
  );
};
